import script from "./TeamPerformanceCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamPerformanceCard.vue?vue&type=script&lang=ts&setup=true"

import "./TeamPerformanceCard.vue?vue&type=style&index=0&id=85a5a0ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85a5a0ec"]])

export default __exports__